import generatedSiteConfig from './generated/site-config.generated.json';

export const fallbackSiteConfig = {
  guildName: '同福客栈',
  gameName: '燕云十六声',
  boot: {
    typingSpeed: 120,
    fadeDelayMs: 3000,
    lines: ['好久不见，你去哪儿啦？', '江湖。', '江湖在什么地方？', '我指给你看………………'],
  },
  guildIntro: {
    title: '同福客栈',
    subtitle: '燕云十六声',
    description:
      '《燕云十六声》是一款开放世界武侠历史奇幻动作角色扮演游戏，同福客栈为游戏内百业系统公会组织。',
    extra: '',
  },
  desktopIcons: [],
  startMenu: {
    left: [],
    right: [],
  },
  password_protected: false,
  password_sha1: '',
  heroLogo: '/assets/branding/tongfu-inn-logo.png',
};

const sortByOrder = list => [...list].sort((a, b) => (a.order || 0) - (b.order || 0));
const normalizeAction = action => {
  if (action === 'ie' || action === 'window' || action === 'redirect') {
    return action;
  }
  return 'redirect';
};
const normalizeProtectedFlag = value => value === true;
const normalizeSha1 = value => (typeof value === 'string' ? value.trim().toLowerCase() : '');

const normalizeDesktopIcons = icons =>
  sortByOrder(icons || []).map((icon, index) => ({
    order: index + 1,
    name: icon.name,
    icon: icon.icon,
    url: icon.url,
    action: normalizeAction(icon.action),
    password_protected: normalizeProtectedFlag(icon.password_protected),
  }));

const normalizeStartMenuFromDesktop = desktopIcons => [
  {
    order: 1,
    name: '所有程序',
    icon: '/assets/xp-icons/programs.png',
    children: desktopIcons.map((icon, index) => ({
      order: index + 1,
      name: icon.name,
      icon: icon.icon,
      url: icon.url,
      action: normalizeAction(icon.action),
      password_protected: normalizeProtectedFlag(icon.password_protected),
    })),
  },
];

export const toStartMenuItems = items =>
  sortByOrder(items || []).map(item => {
    const children = toStartMenuItems(item.children || []);
    if (children.length) {
      return {
        type: 'menu',
        text: item.name,
        icon: item.icon,
        items: children,
        url: item.url || null,
        action: normalizeAction(item.action),
        password_protected: normalizeProtectedFlag(item.password_protected),
      };
    }
    return {
      type: 'item',
      text: item.name,
      icon: item.icon,
      url: item.url || null,
      action: normalizeAction(item.action),
      password_protected: normalizeProtectedFlag(item.password_protected),
    };
  });

export const mergeDesktopIcons = (configIcons, builtInIcons) => {
  const externalIcons = sortByOrder(configIcons || []).map((icon, index) => ({
    id: index,
    order: index + 1,
    title: icon.name,
    icon: icon.icon,
    isFocus: false,
    actionType: 'config',
    action: normalizeAction(icon.action),
    url: icon.url,
    passwordProtected: normalizeProtectedFlag(icon.password_protected),
  }));

  const nextId = externalIcons.length;
  const systemIcons = builtInIcons.map((icon, index) => ({
    ...icon,
    id: nextId + index,
    order: nextId + index + 1,
    isFocus: false,
  }));

  return [...externalIcons, ...systemIcons];
};

export const loadSiteConfig = () => {
  const raw = generatedSiteConfig || {};
  const desktopIcons = normalizeDesktopIcons(raw.desktopIcons);

  return {
    ...fallbackSiteConfig,
    ...raw,
    desktopIcons,
    password_protected: normalizeProtectedFlag(raw.password_protected),
    password_sha1: normalizeSha1(raw.password_sha1),
    boot: {
      ...fallbackSiteConfig.boot,
      ...(raw.boot || {}),
    },
    guildIntro: {
      ...fallbackSiteConfig.guildIntro,
      ...(raw.guildIntro || {}),
    },
    startMenu: {
      right: ((raw.startMenu || {}).right || fallbackSiteConfig.startMenu.right),
      left: normalizeStartMenuFromDesktop(desktopIcons),
    },
  };
};
